import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const ButtonWrapper = styled.div`
	button {
		border: 1px solid ${colors.grey3};
		border-radius: 0;
	}
`;
